import { createGlobalStyle } from '../core';
export default createGlobalStyle `
	[data-tippy-root] {
		max-width: calc(100vw - 10px);
	}

	.tippy-box {
		position: relative;
		transition-property: transform, visibility, opacity;
	}

	.tippy-box[data-animation=fade][data-state=hidden] {
		opacity: 0;
	}

	.tippy-content {
		position: relative;
		z-index: 1;
	}
`;
